<ion-grid class="ion-no-padding">
  <ion-row class="ion-padding-vertical">
    @if (vehicle().p11dBasic !== null) {
    <ion-col size="4">
      <div class="label">{{ 'LABEL_P11D' | translate }}</div>
      <div class="value">{{ vehicle().p11dBasic | currency:'GBP' }}</div>
    </ion-col>
    }
    @if (selectedBIK() === 20 && vehicle().bik20Total !== null) {
    <ion-col size="4">
      <div class="label">{{ 'LABEL_BIK_20' | translate }}</div>
      <div class="value">{{ vehicle().bik20Total | currency:'GBP' }}</div>
    </ion-col>
    }
    @if (selectedBIK() === 40 && vehicle().bik40Total !== null) {
    <ion-col size="4">
      <div class="label">{{ 'LABEL_BIK_40' | translate }}</div>
      <div class="value">{{ vehicle().bik40Total | currency:'GBP' }}</div>
    </ion-col>
    }
    @if (selectedBIK() === 45 && vehicle().bik45Total !== null) {
    <ion-col size="4">
      <div class="label">{{ 'LABEL_BIK_45' | translate }}</div>
      <div class="value">{{ vehicle().bik45Total | currency:'GBP' }}</div>
    </ion-col>
    }
    @if (vehicle().tradeAmount != null) {
    <ion-col size="4">
      <div class="label">{{ vehicle().financeLabel | translate }}</div>
      <div class="value">{{ vehicle().tradeAmount | currency:'GBP' }}</div>
    </ion-col>
    }
  </ion-row>

  <ion-row class="ion-padding-vertical">
    @if (vehicle().fuelType) {
    <ion-col size="4">
      <div class="label">{{ 'LABEL_FUEL_TYPE' | translate }}</div>
      <div class="value">{{ vehicle().fuelType }}</div>
    </ion-col>
    }
    @if (vehicle().fuelType !== FuelType.Electric) {
      @if(vehicle().mpg != null) {
      <ion-col size="4">
        <div class="label">{{ 'LABEL_MPG' | translate }}</div>
        <div class="value">{{ vehicle().mpg }}</div>
      </ion-col>
      }
      @if(vehicle().co2gPerKm != null) {
      <ion-col size="4">
        <div class="label">{{'LABEL_CO2' | translate }}</div>
        <div class="value">{{ vehicle().co2gPerKm }} g/km</div>
      </ion-col>
      }
    }
    @else {
      @if(vehicle().evMiles != null) {
      <ion-col size="4">
        <div class="label">{{ 'LABEL_EV_MILES' | translate }}</div>
        <div class="value">{{ vehicle().evMiles }}</div>
      </ion-col>
      }
    }
  </ion-row>

  @if (vehicle().fuelType === FuelType.Hybrid && vehicle().evMiles != null) {
  <ion-row class="ion-padding-vertical">
    <ion-col size="12">
      <div class="label">{{ 'LABEL_EV_MILES' | translate }}</div>
      <div class="value">{{ vehicle().evMiles }}</div>
    </ion-col>
  </ion-row>
  }
</ion-grid>
